import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import {IChangePasswordParams} from '../../authentication.route';
import ErrorService from '../../../core/errors/service/ErrorService';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import TSPasswordData from '../../../models/TSPasswordData';
import PasswordStrengthService from '../../../core/service/PasswordStrengthService';
import ITimeoutService = angular.ITimeoutService;
import ILocationService = angular.ILocationService;
import ILogService = angular.ILogService;
import IFormController = angular.IFormController;
import ITranslateService = angular.translate.ITranslateService;
let template = require('./passwordChangeView.html');
require('./passwordChangeView.scss');

export class PasswordChangedComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = PasswordChangedViewController;
    controllerAs = 'vm';
}

export class PasswordChangedViewController {

    static $inject: string[] = ['$state', '$stateParams', 'BenutzerRS',
        '$location', '$log', 'ErrorService', 'CONSTANTS', '$translate', '$timeout', 'PasswordStrengthService'];

    private model: TSPasswordData;
    private form: IFormController;

    constructor(private $state: IStateService, private $stateParams: IChangePasswordParams,
                private benutzerRS: BenutzerRS, private $location: ILocationService,
                private $log: ILogService, private errorService: ErrorService, private CONSTANTS: any,
                private $translate: ITranslateService, private $timeout: ITimeoutService,
                private passwordStrengthService: PasswordStrengthService) {

    }

    $onInit() {
        this.errorService.clearAll();
        let email: string = '';
        if (this.$stateParams.email) {
            email = decodeURIComponent(this.$stateParams.email);
        }
        let token = this.$stateParams.changetoken || '';
        this.model = new TSPasswordData(email, token);

    }

    public saveClicked() {

        this.errorService.clearAll();
        if (this.passwordStrengthService.checkIfValid(this.model.password, this.model.passwordRepeat)) {
            this.benutzerRS.resetPassword(this.model)
                .then(() => {
                    let successmsg = this.$translate.instant('LOGIN_CHANGED');
                    this.errorService.addMesageAsInfo(successmsg);
                    this.$state.go('start');
                    this.$timeout(() => {
                        this.errorService.clearAll();
                    }, 5000);

                }).catch(() => {
                this.errorService.addMesageAsError(this.$translate.instant(('ERROR_PW_CHANGE')))
            });

        }

    }



}



// WEBPACK FOOTER //
// ./src/app/authentication/component/passwordChangeView/passwordChangeView.ts